import { createSelector } from 'reselect';
import { leaderboardSelector } from './simple-selectors';

export const leaderboardNavSelector = createSelector(
    leaderboardSelector,
    (leaderboard) => leaderboard.nav
);
